import xtend from 'xtend'
import _ from 'underscore'
import struct from '@nichoth/observ/struct'
import observ from '@nichoth/observ/observ'
import Model from '@nichoth/observ/model'
import ReadOnlyModel from '../../models'

// @TODO handle case with no results for query
function EventModel ({ io }) {
    return Model({
        io: { get: io.get },
        state: {
            hasResults: observ(null),
            data: struct({})
        },
        update: {
            get: function (state, res) {
                if (!state.hasFetched()) state.hasFetched.set(true)
                var hasRes = !!res.data.length
                state.hasResults.set(hasRes)
                state.data.set(hasRes ? res.data[0] : {})
            }
        }
    })
}

function CategoriesModel ({ io }) {
    return Model({
        io: {
            get: io.get
        },
        state: {
            data: observ([])
        },
        update: {
            get: function (state, res) {
                state.data.set(_(res.data).sortBy(cat => {
                    return cat.categoryName.toLowerCase()
                }))
            }
        }
    })
}

function PendingQuery (initState) {
    return struct(xtend({
        startDate: observ(null),
        endDate: observ(null),
        category: observ(null)
    }, initState))
}

PendingQuery.set = function (state, data) {
    state.set(xtend(state() || {}, data))
}

PendingQuery.reset = function (state) {
    state.set({
        startDate: null,
        endDate: null,
        category: null
    })
}

function Models ({ eventID, io, api }) {
    var models = {
        viewerCounts: ReadOnlyModel({ io: { get: io.getViewerCounts } }),
        topDevices: ReadOnlyModel({ io: { get: io.getTopDevices } }),
        topOS: ReadOnlyModel({ io: { get: io.getTopOS } }),
        topBrowsers: ReadOnlyModel({ io: { get: io.getTopBrowsers } }),

        topStates: Model({
            io: { get: io.getTopStates },
            state: { data: observ([]) },
            update: {
                get: (state, res) => state.data.set(toSortedArray(res.result))
            }
        }),

        topCities: Model({
            io: { get: io.getTopCities },
            state: { data: observ([]) },
            update: {
                get: (state, res) => state.data.set(toSortedArray(res.result))
            }
        }),

        topReferrers: Model({
            io: { get: io.getTopReferrers },
            state: { data: observ([]) },
            update: {
                get: function (state, res) {
                    var data = Object.keys(res.result)
                        .reduce(function (acc, k) {
                            acc.push({ name: k, count: res.result[k] })
                            return acc
                        }, [])
                    state.data.set(data)
                }
            }
        }),

        averagePlayLen: ReadOnlyModel({ io: { get: io.getAvgPlayLen } }),
        categories: CategoriesModel({ io: api.categories })
    }

    models.mostWatchedEvents = Model({
        io: { get: io.getMostWatched },
        state: { data: observ([]) },
        update: {
            get: (state, res) => {
                state.data.set(_.sortBy(res.result, 'plays').reverse())
            }
        }
    })

    if (eventID) {
        models.event = EventModel({ io: api.events })

        models.viewerSessions = Model({
            io: { get: io.getViewerSessions },
            state: {
                data: observ([])
            },
            update: {
                get: function (state, res) {
                    state.hasFetched.set(true)
                    state.data.set(res.result)
                }
            }
        })
    }

    return models
}

Models.createState = function (models, { defaultQuery }) {
    var modelStates = Object.keys(models).reduce(function (acc, k) {
        acc[k] = Model.getState(models[k])
        return acc
    }, {})

    var state = struct(xtend(modelStates, {
        query: struct(defaultQuery),
        pendingQuery: PendingQuery(defaultQuery),
        isFetchPending: observ(false)
    }))

    return state
}

Models.PendingQuery = PendingQuery
export default Models

function toSortedArray (res) {
    var arr = Object.keys(res).reduce(function (acc, k) {
        acc.push({ name: k, value: res[k] })
        return acc
    }, [])
    return _(arr).sortBy('value').reverse()
}
